import {
  GET_BUYER,
  GET_BUYER_ERROR,
  GET_BUYER_KPIS,
  GET_BUYER_KPIS_ERROR,
  GET_BUYER_KPIS_SUCCESS,
  GET_BUYER_SUCCESS
} from './BuyerSection.actions'

const buyerSectionState = {
  amount: undefined,
  biddings: undefined,
  entCode: undefined,
  error: undefined,
  idEntity: undefined,
  loadingBuyer: true,
  loadingKPIs: true,
  month: undefined,
  monthNumber: undefined,
  name: '',
  orders: undefined,
  percentAmountAcumCLP: undefined,
  percentAmountMonthCLP: undefined,
  sector: undefined,
  totalAmount: undefined
}

/**
 * The buyer section's reducer.
 */
const buyerSectionReducer = (state = buyerSectionState, { payload, type }) => {
  switch (type) {
    case GET_BUYER: {
      return { ...state, loadingBuyer: true }
    }
    case GET_BUYER_ERROR: {
      return { ...state, error: payload.error, loadingBuyer: false }
    }
    case GET_BUYER_SUCCESS: {
      return { ...state, ...payload, loadingBuyer: false }
    }
    case GET_BUYER_KPIS: {
      return { ...state, loadingKPIs: true }
    }
    case GET_BUYER_KPIS_ERROR: {
      return { ...state, error: payload.error, loadingKPIs: false }
    }
    case GET_BUYER_KPIS_SUCCESS: {
      return { ...state, ...payload, loadingKPIs: false }
    }
    default: {
      return state
    }
  }
}

export default buyerSectionReducer
